import { FC, ReactNode } from 'react';

interface ManualSolicitationBodyProps {
	children: ReactNode;
}

const ManualSolicitationBody: FC<ManualSolicitationBodyProps> = ({
	children,
}) => {
	return (
		<div className="flex flex-col h-full w-full pl-6 pr-4 gap-4">
			<div className="flex flex-col h-[calc(100vh-105px)] w-full overflow-y-auto scroll-smooth">
				{children}
			</div>
		</div>
	);
};

export default ManualSolicitationBody;
